/**
 * Swedish profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Swedish
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 179
 */

export const SV = {
  "metadata": {
    "name": "Swedish",
    "code": "sv",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 179
  },
  "words": [
    {
      "word": "tusan",
      "severity": 1,
      "categories": [
        "general",
        "euphemism"
      ],
      "variations": [
        "tussan"
      ],
      "case_sensitive": false,
      "context_notes": "Euphemism for 'thousand', very mild curse word similar to 'darn'",
      "target_type": "general"
    },
    {
      "word": "sjutton",
      "severity": 1,
      "categories": [
        "general",
        "euphemism"
      ],
      "variations": [
        "17"
      ],
      "case_sensitive": false,
      "context_notes": "Number seventeen used as mild euphemism, equivalent to 'heck'",
      "target_type": "general"
    },
    {
      "word": "attans",
      "severity": 1,
      "categories": [
        "general",
        "euphemism"
      ],
      "variations": [
        "attan"
      ],
      "case_sensitive": false,
      "context_notes": "Old form of eighteen, mild exclamation similar to 'dang'",
      "target_type": "general"
    },
    {
      "word": "kors",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "korsan"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'cross', mild religious exclamation",
      "target_type": "general"
    },
    {
      "word": "järnspikar",
      "severity": 1,
      "categories": [
        "general",
        "euphemism"
      ],
      "variations": [
        "järnspik"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'iron nails', old-fashioned mild exclamation",
      "target_type": "general"
    },
    {
      "word": "gudars skymning",
      "severity": 1,
      "categories": [
        "general",
        "religious",
        "euphemism"
      ],
      "variations": [
        "gudars"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'twilight of the gods', old-fashioned mild curse",
      "target_type": "general"
    },
    {
      "word": "för bövelen",
      "severity": 1,
      "categories": [
        "general",
        "euphemism"
      ],
      "variations": [
        "bövelen"
      ],
      "case_sensitive": false,
      "context_notes": "Equivalent to 'for goodness sake', mild exclamation",
      "target_type": "general"
    },
    {
      "word": "herre gud",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "herregud"
      ],
      "case_sensitive": false,
      "context_notes": "Lord God, mild religious exclamation similar to 'Oh my God'",
      "target_type": "general"
    },
    {
      "word": "jisses",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "jösses"
      ],
      "case_sensitive": false,
      "context_notes": "Taboo deformation for Jesus, mild expression of surprise",
      "target_type": "general"
    },
    {
      "word": "fy",
      "severity": 1,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "fysan",
        "fy fan"
      ],
      "case_sensitive": false,
      "context_notes": "Expression of disgust, equivalent to 'ugh' or 'yuck'",
      "target_type": "general"
    },
    {
      "word": "skit",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "skitt",
        "sk1t",
        "skit-"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'shit', can be used as emphasis like 'very' in compounds",
      "target_type": "general"
    },
    {
      "word": "fan",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "f4n",
        "f@n",
        "faen"
      ],
      "case_sensitive": false,
      "context_notes": "Devil/Satan reference, equivalent to 'damn' or 'fuck', very common",
      "target_type": "general"
    },
    {
      "word": "helvete",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "helvetet",
        "helvte",
        "h3lvete"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'hell', used similarly to English 'hell'",
      "target_type": "general"
    },
    {
      "word": "satan",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "satans",
        "s4tan",
        "sat4n"
      ],
      "case_sensitive": false,
      "context_notes": "Literal invocation of Satan, used as strong exclamation",
      "target_type": "general"
    },
    {
      "word": "jävel",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "djävel",
        "jävla",
        "jävlar",
        "j4vel"
      ],
      "case_sensitive": false,
      "context_notes": "Devil reference, very versatile curse word, equivalent to English 'fuck'",
      "target_type": "general"
    },
    {
      "word": "förbannad",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "förbannat",
        "förbaskad",
        "förbaskat"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'damned' or 'cursed', moderate profanity",
      "target_type": "general"
    },
    {
      "word": "piss",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "p1ss",
        "piss-"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'piss', used as interjection and prefix",
      "target_type": "general"
    },
    {
      "word": "idiot",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "1diot",
        "idi0t"
      ],
      "case_sensitive": false,
      "context_notes": "Intelligence-based insult, same as English 'idiot'",
      "target_type": "general"
    },
    {
      "word": "dumhuvud",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "dumhuvudet"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'stupid head', moderate intelligence insult",
      "target_type": "general"
    },
    {
      "word": "pucko",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "puck0"
      ],
      "case_sensitive": false,
      "context_notes": "Slang for 'stupid person', derogatory intelligence insult",
      "target_type": "general"
    },
    {
      "word": "klantskalle",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "klant"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'bonehead', moderate intelligence insult",
      "target_type": "general"
    },
    {
      "word": "mongo",
      "severity": 2,
      "categories": [
        "general",
        "intelligence",
        "ableist"
      ],
      "variations": [
        "m0ngo"
      ],
      "case_sensitive": false,
      "context_notes": "Slang meaning 'retard' or 'weirdo', considered offensive",
      "target_type": "general"
    },
    {
      "word": "nöt",
      "severity": 2,
      "categories": [
        "general",
        "intelligence",
        "animal"
      ],
      "variations": [
        "n0t"
      ],
      "case_sensitive": false,
      "context_notes": "Old term for cattle, used as mild insult meaning 'stupid'",
      "target_type": "general"
    },
    {
      "word": "apa",
      "severity": 2,
      "categories": [
        "general",
        "intelligence",
        "animal"
      ],
      "variations": [
        "aphjärna",
        "4pa"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'ape/monkey', implies stupidity or brutishness",
      "target_type": "general"
    },
    {
      "word": "kåt",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "k4t"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'horny', sexual reference but not extremely offensive",
      "target_type": "general"
    },
    {
      "word": "knulla",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [
        "knull",
        "knullar",
        "knullat"
      ],
      "case_sensitive": false,
      "context_notes": "Most offensive sexual term, equivalent to English 'fuck'",
      "target_type": "general"
    },
    {
      "word": "hora",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [
        "h0ra",
        "hor4"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'whore', strong sexual insult primarily targeting women",
      "target_type": "general"
    },
    {
      "word": "fitta",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [
        "f1tta",
        "fitt4"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive, equivalent to English 'cunt', strongest sexual profanity",
      "target_type": "general"
    },
    {
      "word": "kuk",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [
        "k*k",
        "kook"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'cock/dick', strong sexual profanity used interjectively",
      "target_type": "general"
    },
    {
      "word": "bög",
      "severity": 3,
      "categories": [
        "sexual",
        "lgbtq",
        "slur"
      ],
      "variations": [
        "b0g",
        "bögar"
      ],
      "case_sensitive": false,
      "context_notes": "Homosexual slur, partially reappropriated but still offensive",
      "target_type": "lgbtq"
    },
    {
      "word": "blatte",
      "severity": 4,
      "categories": [
        "ethnic",
        "racist",
        "slur"
      ],
      "variations": [
        "bl4tte"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive derogatory term for non-Swedish immigrants",
      "target_type": "ethnic"
    },
    {
      "word": "svartskalle",
      "severity": 4,
      "categories": [
        "ethnic",
        "racist",
        "slur"
      ],
      "variations": [
        "svartsk4lle"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive term for people with dark skin/hair",
      "target_type": "ethnic"
    },
    {
      "word": "turk",
      "severity": 3,
      "categories": [
        "ethnic",
        "slur"
      ],
      "variations": [
        "t*rk"
      ],
      "case_sensitive": false,
      "context_notes": "Generic derogatory term for immigrants, offensive",
      "target_type": "ethnic"
    },
    {
      "word": "fan ta dig",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "phrase"
      ],
      "variations": [
        "fan ta er"
      ],
      "case_sensitive": false,
      "context_notes": "Strong curse phrase meaning 'go to hell' or 'fuck you'",
      "target_type": "general"
    },
    {
      "word": "dra åt helvete",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "phrase"
      ],
      "variations": [
        "stick åt helvete",
        "far åt helvete"
      ],
      "case_sensitive": false,
      "context_notes": "Strong curse phrase meaning 'go to hell'",
      "target_type": "general"
    },
    {
      "word": "fan i helvete",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "phrase"
      ],
      "variations": [
        "fan i helvetet"
      ],
      "case_sensitive": false,
      "context_notes": "Strong compound curse combining 'fan' and 'helvete', 'fucking hell'",
      "target_type": "general"
    },
    {
      "word": "satans helvetes förbannade jävla fan",
      "severity": 4,
      "categories": [
        "general",
        "religious",
        "phrase",
        "compound"
      ],
      "variations": [
        "satans jävla helvete"
      ],
      "case_sensitive": false,
      "context_notes": "Maximum intensity compound curse combining multiple religious profanities",
      "target_type": "general"
    },
    {
      "word": "fan jävla skit",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "scatological",
        "phrase"
      ],
      "variations": [
        "jävla skit"
      ],
      "case_sensitive": false,
      "context_notes": "Strong compound curse combining religious and scatological terms",
      "target_type": "general"
    },
    {
      "word": "skitstövel",
      "severity": 3,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "skitst0vel"
      ],
      "case_sensitive": false,
      "context_notes": "Strong insult literally meaning 'shit boot', equivalent to 'bastard'",
      "target_type": "general"
    },
    {
      "word": "jävlar anamma",
      "severity": 2,
      "categories": [
        "general",
        "religious",
        "phrase"
      ],
      "variations": [
        "anamma"
      ],
      "case_sensitive": false,
      "context_notes": "Moderate exclamation, 'anamma' is euphemism for 'name of God'",
      "target_type": "general"
    },
    {
      "word": "gå och dö",
      "severity": 4,
      "categories": [
        "general",
        "violence",
        "phrase"
      ],
      "variations": [
        "dö"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive phrase meaning 'go and die' or 'kill yourself'",
      "target_type": "general"
    },
    {
      "word": "skit-snygg",
      "severity": 1,
      "categories": [
        "general",
        "scatological",
        "compound"
      ],
      "variations": [
        "skitsnygg"
      ],
      "case_sensitive": false,
      "context_notes": "Using 'skit' as intensifier meaning 'very good looking'",
      "target_type": "general"
    },
    {
      "word": "skit-ful",
      "severity": 2,
      "categories": [
        "general",
        "scatological",
        "compound"
      ],
      "variations": [
        "skitful"
      ],
      "case_sensitive": false,
      "context_notes": "Using 'skit' as intensifier meaning 'very ugly'",
      "target_type": "general"
    },
    {
      "word": "attans bananer",
      "severity": 1,
      "categories": [
        "general",
        "euphemism",
        "phrase"
      ],
      "variations": [
        "bananer"
      ],
      "case_sensitive": false,
      "context_notes": "Mild compound insult combining 'attans' with 'bananas'",
      "target_type": "general"
    },
    {
      "word": "fan-jävel",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "compound"
      ],
      "variations": [
        "fanjävel"
      ],
      "case_sensitive": false,
      "context_notes": "Strong compound combining 'fan' and 'jävel' for emphasis",
      "target_type": "general"
    },
    {
      "word": "helvetes-jävel",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "compound"
      ],
      "variations": [
        "helvetesjävel"
      ],
      "case_sensitive": false,
      "context_notes": "Strong compound combining 'helvete' and 'jävel'",
      "target_type": "general"
    },
    {
      "word": "satan-jävel",
      "severity": 3,
      "categories": [
        "general",
        "religious",
        "compound"
      ],
      "variations": [
        "satanjävel"
      ],
      "case_sensitive": false,
      "context_notes": "Strong compound combining 'satan' and 'jävel'",
      "target_type": "general"
    },
    {
      "word": "piss-träd",
      "severity": 2,
      "categories": [
        "general",
        "scatological",
        "compound"
      ],
      "variations": [
        "pissträ"
      ],
      "case_sensitive": false,
      "context_notes": "Moderate compound insult literally 'piss tree'",
      "target_type": "general"
    },
    {
      "word": "skit-träd",
      "severity": 2,
      "categories": [
        "general",
        "scatological",
        "compound"
      ],
      "variations": [
        "skitträd"
      ],
      "case_sensitive": false,
      "context_notes": "Moderate compound insult literally 'shit tree'",
      "target_type": "general"
    },
    {
      "word": "djävulskap",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "djävulsk4p"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'devilry' or 'deviltry', moderate religious curse",
      "target_type": "general"
    },
    {
      "word": "förbannelse",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "förb4nnelse"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'curse' or 'damnation', moderate religious profanity",
      "target_type": "general"
    },
    {
      "word": "hemsk",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "h3msk"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'awful' or 'terrible', mild negative descriptor",
      "target_type": "general"
    },
    {
      "word": "äcklig",
      "severity": 1,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "äckl1g"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'disgusting' or 'gross', mild expression of disgust",
      "target_type": "general"
    },
    {
      "word": "vidrig",
      "severity": 2,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "vidr1g"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'disgusting' or 'repulsive', stronger than äcklig",
      "target_type": "general"
    },
    {
      "word": "rövhål",
      "severity": 3,
      "categories": [
        "general",
        "scatological",
        "vulgar"
      ],
      "variations": [
        "r0vhål",
        "röv"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'asshole', strong vulgar insult",
      "target_type": "general"
    },
    {
      "word": "arsle",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "4rsle"
      ],
      "case_sensitive": false,
      "context_notes": "Mild term for 'butt' or 'bottom', less offensive than röv",
      "target_type": "general"
    },
    {
      "word": "bajskorv",
      "severity": 2,
      "categories": [
        "general",
        "scatological",
        "childish"
      ],
      "variations": [
        "bajs"
      ],
      "case_sensitive": false,
      "context_notes": "Childish term literally 'poop sausage', moderate scatological",
      "target_type": "general"
    },
    {
      "word": "fittnylle",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [
        "f1ttnylle"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound using 'fitta', highly vulgar",
      "target_type": "general"
    },
    {
      "word": "kuksuger",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "lgbtq"
      ],
      "variations": [
        "kuksug3r"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive sexual insult meaning 'cocksucker'",
      "target_type": "general"
    },
    {
      "word": "fittslem",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [
        "f1ttslem"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely offensive compound using 'fitta', highly vulgar",
      "target_type": "general"
    },
    {
      "word": "kukhuvud",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [
        "kukhuvudet"
      ],
      "case_sensitive": false,
      "context_notes": "Strong vulgar insult literally 'dickhead'",
      "target_type": "general"
    },
    {
      "word": "runkare",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [
        "r*nkare",
        "runka"
      ],
      "case_sensitive": false,
      "context_notes": "Strong sexual insult referring to masturbation",
      "target_type": "general"
    },
    {
      "word": "slyna",
      "severity": 3,
      "categories": [
        "sexual",
        "misogynistic"
      ],
      "variations": [
        "sl*na"
      ],
      "case_sensitive": false,
      "context_notes": "Strong derogatory term for women, similar to 'slut'",
      "target_type": "general"
    },
    {
      "word": "ludder",
      "severity": 3,
      "categories": [
        "sexual",
        "misogynistic"
      ],
      "variations": [
        "l*dder"
      ],
      "case_sensitive": false,
      "context_notes": "Strong derogatory term for women, similar to 'whore'",
      "target_type": "general"
    },
    {
      "word": "käring",
      "severity": 2,
      "categories": [
        "general",
        "misogynistic"
      ],
      "variations": [
        "k4ring"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for older women, equivalent to 'hag' or 'old witch'",
      "target_type": "general"
    },
    {
      "word": "gubbe",
      "severity": 2,
      "categories": [
        "general",
        "ageist"
      ],
      "variations": [
        "gubbar"
      ],
      "case_sensitive": false,
      "context_notes": "Can be derogatory for older men when used dismissively",
      "target_type": "general"
    },
    {
      "word": "mesar",
      "severity": 2,
      "categories": [
        "general",
        "weakness"
      ],
      "variations": [
        "mes"
      ],
      "case_sensitive": false,
      "context_notes": "Insult implying weakness or cowardice, 'wimp'",
      "target_type": "general"
    },
    {
      "word": "fegis",
      "severity": 2,
      "categories": [
        "general",
        "weakness"
      ],
      "variations": [
        "f3gis"
      ],
      "case_sensitive": false,
      "context_notes": "Insult meaning 'coward' or 'chicken'",
      "target_type": "general"
    },
    {
      "word": "kräk",
      "severity": 2,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "kr4k"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'vomit', used as insult for disgusting person",
      "target_type": "general"
    },
    {
      "word": "slem",
      "severity": 2,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "sl3m"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'slime' or 'mucus', used as disgusting insult",
      "target_type": "general"
    },
    {
      "word": "snorunge",
      "severity": 2,
      "categories": [
        "general",
        "ageist"
      ],
      "variations": [
        "snor*nge"
      ],
      "case_sensitive": false,
      "context_notes": "Derogatory term for young person, 'snotty kid'",
      "target_type": "general"
    },
    {
      "word": "pajas",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "p4jas"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'clown' in derogatory sense, implies foolishness",
      "target_type": "general"
    },
    {
      "word": "knäppskalle",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "knäppsk4lle"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'crackpot' or 'nutcase', intelligence insult",
      "target_type": "general"
    },
    {
      "word": "stolpskott",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "st0lpskott"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'post shot', meaning someone who missed target, implies stupidity",
      "target_type": "general"
    },
    {
      "word": "tölp",
      "severity": 2,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "t0lp"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'oaf' or 'clumsy fool', moderate intelligence insult",
      "target_type": "general"
    },
    {
      "word": "kåk",
      "severity": 1,
      "categories": [
        "general",
        "prison"
      ],
      "variations": [
        "k4k"
      ],
      "case_sensitive": false,
      "context_notes": "Slang for prison or jail, mild criminal reference",
      "target_type": "general"
    },
    {
      "word": "soppa",
      "severity": 1,
      "categories": [
        "general",
        "mess"
      ],
      "variations": [
        "s0ppa"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'soup', used to describe messy situation",
      "target_type": "general"
    },
    {
      "word": "pannkaka",
      "severity": 1,
      "categories": [
        "general",
        "intelligence"
      ],
      "variations": [
        "pannk4ka"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'pancake', mild insult implying flatness or stupidity",
      "target_type": "general"
    },
    {
      "word": "kött",
      "severity": 2,
      "categories": [
        "general",
        "objectification"
      ],
      "variations": [
        "k0tt"
      ],
      "case_sensitive": false,
      "context_notes": "Literally 'meat', can be used to objectify people",
      "target_type": "general"
    },
    {
      "word": "packet",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "p4cket"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'riffraff' or 'scum', moderate general insult",
      "target_type": "general"
    },
    {
      "word": "as",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "4s"
      ],
      "case_sensitive": false,
      "context_notes": "Can be used as intensifier or mild insult, context-dependent",
      "target_type": "general"
    },
    {
      "word": "ynkrygg",
      "severity": 2,
      "categories": [
        "general",
        "weakness"
      ],
      "variations": [
        "ynkr*gg"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'wretch' or 'miserable person', implies pathetic weakness",
      "target_type": "general"
    },
    {
      "word": "usling",
      "severity": 2,
      "categories": [
        "general",
        "weakness"
      ],
      "variations": [
        "usl1ng"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'wretch' or 'miserable creature', implies contempt",
      "target_type": "general"
    },
    {
      "word": "kräk",
      "severity": 2,
      "categories": [
        "general",
        "disgust"
      ],
      "variations": [
        "kr4k"
      ],
      "case_sensitive": false,
      "context_notes": "Meaning 'puke' or 'vomit', used as disgusting insult",
      "target_type": "general"
    },
    {
      "word": "fanken",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Devil variation, religious profanity",
      "target_type": "general"
    },
    {
      "word": "farao",
      "severity": 1,
      "categories": [
        "religious",
        "euphemism"
      ],
      "variations": [
        "fy farao"
      ],
      "case_sensitive": false,
      "context_notes": "Pharaoh as mild euphemism",
      "target_type": "general"
    },
    {
      "word": "fasen",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "The devil, religious profanity",
      "target_type": "general"
    },
    {
      "word": "fasiken",
      "severity": 1,
      "categories": [
        "religious",
        "euphemism"
      ],
      "variations": [
        "fy fasiken"
      ],
      "case_sensitive": false,
      "context_notes": "Mild religious euphemism",
      "target_type": "general"
    },
    {
      "word": "fasingen",
      "severity": 1,
      "categories": [
        "religious",
        "euphemism"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Mild religious euphemism",
      "target_type": "general"
    },
    {
      "word": "fanders",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [
        "åt fanders"
      ],
      "case_sensitive": false,
      "context_notes": "Devil variation",
      "target_type": "general"
    },
    {
      "word": "fanskap",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Devilish thing, religious profanity",
      "target_type": "general"
    },
    {
      "word": "jädra",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Mild curse, religious variation",
      "target_type": "general"
    },
    {
      "word": "jäkla",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Damn, religious profanity",
      "target_type": "general"
    },
    {
      "word": "förjävla",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Pre-devil, religious profanity",
      "target_type": "general"
    },
    {
      "word": "djävlar anamma",
      "severity": 2,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Devils too, religious phrase",
      "target_type": "general"
    },
    {
      "word": "för helvete",
      "severity": 3,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "For hell's sake, strong religious phrase",
      "target_type": "general"
    },
    {
      "word": "i helvete",
      "severity": 3,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "In hell, religious phrase",
      "target_type": "general"
    },
    {
      "word": "in i helvete",
      "severity": 3,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Into hell, religious phrase",
      "target_type": "general"
    },
    {
      "word": "åt helvete",
      "severity": 3,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "To hell, religious phrase",
      "target_type": "general"
    },
    {
      "word": "helvetes jävla skit",
      "severity": 4,
      "categories": [
        "religious",
        "scatological",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Hell's damn shit, very strong compound",
      "target_type": "general"
    },
    {
      "word": "helvetes skit",
      "severity": 3,
      "categories": [
        "religious",
        "scatological",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Hell's shit, strong compound",
      "target_type": "general"
    },
    {
      "word": "helvetes jävla fanskap",
      "severity": 4,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Hell's damn devilish thing, very strong compound",
      "target_type": "general"
    },
    {
      "word": "satan i helvetes jävla skit",
      "severity": 4,
      "categories": [
        "religious",
        "scatological",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Satan in hell's damn shit, extremely strong compound",
      "target_type": "general"
    },
    {
      "word": "förbaskad",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Cursed, religious profanity",
      "target_type": "general"
    },
    {
      "word": "förbannat",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Damned, religious profanity",
      "target_type": "general"
    },
    {
      "word": "fittig",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Related to fitta, extremely offensive",
      "target_type": "general"
    },
    {
      "word": "discofitta",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Disco cunt, extremely offensive compound",
      "target_type": "general"
    },
    {
      "word": "snedfitta",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar",
        "misogynistic"
      ],
      "variations": [
        "snefitta"
      ],
      "case_sensitive": false,
      "context_notes": "Crooked cunt, extremely offensive",
      "target_type": "general"
    },
    {
      "word": "kuksås",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Cock sauce, sexual profanity",
      "target_type": "general"
    },
    {
      "word": "kuksugare",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Cocksucker, extremely offensive",
      "target_type": "general"
    },
    {
      "word": "rövknulla",
      "severity": 4,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Ass fuck, extremely offensive",
      "target_type": "general"
    },
    {
      "word": "knulla upp",
      "severity": 3,
      "categories": [
        "sexual",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Fuck up, sexual phrase",
      "target_type": "general"
    },
    {
      "word": "runka av",
      "severity": 3,
      "categories": [
        "sexual",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Jack off, sexual phrase",
      "target_type": "general"
    },
    {
      "word": "onanera",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Masturbate, sexual term",
      "target_type": "general"
    },
    {
      "word": "ligga med",
      "severity": 2,
      "categories": [
        "sexual",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Sleep with, sexual phrase",
      "target_type": "general"
    },
    {
      "word": "avsugning",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Blowjob, sexual term",
      "target_type": "general"
    },
    {
      "word": "sätta på",
      "severity": 2,
      "categories": [
        "sexual",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Put it on/have sex, sexual phrase",
      "target_type": "general"
    },
    {
      "word": "arsel",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Asshole, scatological term",
      "target_type": "general"
    },
    {
      "word": "balle",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Ball/testicle, sexual term",
      "target_type": "general"
    },
    {
      "word": "stånd",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Erection, sexual term",
      "target_type": "general"
    },
    {
      "word": "prutt",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Fart, mild scatological term",
      "target_type": "general"
    },
    {
      "word": "pitt",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Penis slang",
      "target_type": "general"
    },
    {
      "word": "pippa",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Penis slang",
      "target_type": "general"
    },
    {
      "word": "pök",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Penis slang",
      "target_type": "general"
    },
    {
      "word": "pulla",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Sexual slang",
      "target_type": "general"
    },
    {
      "word": "suga",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "To suck - sexual context",
      "target_type": "general"
    },
    {
      "word": "skita",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "To shit, scatological verb",
      "target_type": "general"
    },
    {
      "word": "skit ner dig",
      "severity": 3,
      "categories": [
        "scatological",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Shit yourself, scatological phrase",
      "target_type": "general"
    },
    {
      "word": "skitunge",
      "severity": 3,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Shit kid, scatological insult",
      "target_type": "general"
    },
    {
      "word": "skäggbiff",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Beard steak, derogatory term",
      "target_type": "general"
    },
    {
      "word": "idiotisk",
      "severity": 2,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Idiotic, intelligence insult",
      "target_type": "general"
    },
    {
      "word": "dum",
      "severity": 1,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Stupid, mild intelligence insult",
      "target_type": "general"
    },
    {
      "word": "cp",
      "severity": 4,
      "categories": [
        "ableist",
        "hate_speech"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Cerebral palsy - extremely offensive ableist slur",
      "target_type": "general"
    },
    {
      "word": "dåre",
      "severity": 2,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Fool, intelligence insult",
      "target_type": "general"
    },
    {
      "word": "tok",
      "severity": 2,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Fool, intelligence insult",
      "target_type": "general"
    },
    {
      "word": "idiotjävel",
      "severity": 3,
      "categories": [
        "intelligence",
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Fucking idiot, compound insult",
      "target_type": "general"
    },
    {
      "word": "jävla idiot",
      "severity": 3,
      "categories": [
        "intelligence",
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Damn idiot, compound phrase",
      "target_type": "general"
    },
    {
      "word": "din jävla idiot",
      "severity": 3,
      "categories": [
        "intelligence",
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "You damn idiot, compound phrase",
      "target_type": "general"
    },
    {
      "word": "avskum",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Scum, general insult",
      "target_type": "general"
    },
    {
      "word": "odugling",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Unworthy person, general insult",
      "target_type": "general"
    },
    {
      "word": "kötthuvud",
      "severity": 2,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Meat head, intelligence insult",
      "target_type": "general"
    },
    {
      "word": "köttnacke",
      "severity": 2,
      "categories": [
        "intelligence"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Meat neck, intelligence insult",
      "target_type": "general"
    },
    {
      "word": "neger",
      "severity": 4,
      "categories": [
        "ethnic",
        "racist",
        "hate_speech"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "N-word, extremely offensive racial slur",
      "target_type": "ethnic"
    },
    {
      "word": "nigger",
      "severity": 4,
      "categories": [
        "ethnic",
        "racist",
        "hate_speech"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "N-word, extremely offensive racial slur",
      "target_type": "ethnic"
    },
    {
      "word": "svenne",
      "severity": 2,
      "categories": [
        "ethnic"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Swede slang - can be offensive depending on context",
      "target_type": "ethnic"
    },
    {
      "word": "sjutton också",
      "severity": 1,
      "categories": [
        "euphemism",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Seventeen too, mild euphemism",
      "target_type": "general"
    },
    {
      "word": "sjuttsingen",
      "severity": 1,
      "categories": [
        "euphemism"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Seventeen variation, mild euphemism",
      "target_type": "general"
    },
    {
      "word": "sju tusan",
      "severity": 1,
      "categories": [
        "euphemism",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Seven thousand, mild euphemism",
      "target_type": "general"
    },
    {
      "word": "fy fabian",
      "severity": 1,
      "categories": [
        "disgust",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Ugh fabian, mild expression",
      "target_type": "general"
    },
    {
      "word": "fy sjutton",
      "severity": 1,
      "categories": [
        "disgust",
        "euphemism",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Ugh seventeen, mild expression",
      "target_type": "general"
    },
    {
      "word": "fy skjuttsingen",
      "severity": 1,
      "categories": [
        "disgust",
        "euphemism",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Ugh variation, mild expression",
      "target_type": "general"
    },
    {
      "word": "katten",
      "severity": 1,
      "categories": [
        "euphemism"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "The cat - mild curse",
      "target_type": "general"
    },
    {
      "word": "också",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Too/also - used in curses",
      "target_type": "general"
    },
    {
      "word": "kuk också",
      "severity": 2,
      "categories": [
        "sexual",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Cock too, sexual phrase",
      "target_type": "general"
    },
    {
      "word": "sapristi",
      "severity": 1,
      "categories": [
        "euphemism"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Sapphire - mild exclamation",
      "target_type": "general"
    },
    {
      "word": "helsikes",
      "severity": 2,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Hell variation, religious profanity",
      "target_type": "general"
    },
    {
      "word": "vafan",
      "severity": 2,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "What the devil, religious phrase",
      "target_type": "general"
    },
    {
      "word": "vad sjutton",
      "severity": 1,
      "categories": [
        "euphemism",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "What seventeen, mild phrase",
      "target_type": "general"
    },
    {
      "word": "stake",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Poor/pathetic thing, general insult",
      "target_type": "general"
    },
    {
      "word": "mög",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Mold/scum, general insult",
      "target_type": "general"
    },
    {
      "word": "ditt jävla rövhål",
      "severity": 4,
      "categories": [
        "religious",
        "scatological",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "You damn asshole, strong compound phrase",
      "target_type": "general"
    },
    {
      "word": "jävla kräk",
      "severity": 3,
      "categories": [
        "religious",
        "disgust",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Damn scum, compound phrase",
      "target_type": "general"
    },
    {
      "word": "förbannade jävla idiot",
      "severity": 3,
      "categories": [
        "religious",
        "intelligence",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Damned damn idiot, compound phrase",
      "target_type": "general"
    },
    {
      "word": "heliga jävla körtelfärs",
      "severity": 3,
      "categories": [
        "religious",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Holy fucking gland mince, compound phrase",
      "target_type": "general"
    },
    {
      "word": "bebiskuk",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Baby dick, sexual insult",
      "target_type": "general"
    },
    {
      "word": "inte den vassaste kniven i lådan",
      "severity": 2,
      "categories": [
        "intelligence",
        "phrase"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Not the sharpest knife in the drawer, intelligence phrase",
      "target_type": "general"
    },
    {
      "word": "brutta",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "To grunt/be coarse, offensive action",
      "target_type": "general"
    },
    {
      "word": "moona",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "moonade",
        "moonar",
        "moonat"
      ],
      "case_sensitive": false,
      "context_notes": "To moon, offensive action",
      "target_type": "general"
    },
    {
      "word": "mutta",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "To grunt, crude action",
      "target_type": "general"
    },
    {
      "word": "olla",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Crude action",
      "target_type": "general"
    },
    {
      "word": "subba",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Crude action",
      "target_type": "general"
    },
    {
      "word": "sås",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Sauce - slang context",
      "target_type": "general"
    },
    {
      "word": "hjon",
      "severity": 2,
      "categories": [
        "ableist"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Mentally unstable - archaic ableist term",
      "target_type": "general"
    },
    {
      "word": "fyllo",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Drunk person, derogatory with -o suffix",
      "target_type": "general"
    },
    {
      "word": "full",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Drunk, mild term",
      "target_type": "general"
    },
    {
      "word": "fylla",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Binge-drinking, mild negative term",
      "target_type": "general"
    },
    {
      "word": "fuck",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "English borrowing used in Swedish",
      "target_type": "general"
    },
    {
      "word": "fucking",
      "severity": 3,
      "categories": [
        "sexual",
        "vulgar"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "English borrowing used in Swedish",
      "target_type": "general"
    },
    {
      "word": "bitch",
      "severity": 3,
      "categories": [
        "sexual",
        "misogynistic"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "English borrowing used in Swedish",
      "target_type": "general"
    }
  ]
} as const

export type SVType = typeof SV
